import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SearchCaret = styled.span<React.CSSProperties>`
  bottom: ${2 * Screen.widthRatio}px;
  color: ${Colors['grey']};
  font-size: ${28 * Screen.widthRatio}px;
  font-family: ${Fonts['regular']};
  margin-left: ${1 * Screen.widthRatio}px;
  position: relative;

  animation: fade 1.2s linear infinite;
  -webkit-animation: fade 1.2s linear infinite;

  @keyframes fade {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    51% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
`;

export default SearchCaret;
